import { FC } from 'react';
import { ImageInterstitial, ImageInterstitialProps, ImageInterstitialType } from './components/ImageInterstitial';
import {
  InfoImageInterstitial,
  InfoImageInterstitialProps,
  InfoImageInterstitialType,
} from './components/InfoImageInterstitial';
import { Question, QuestionProps, QuestionType } from './components/Question';
import { SectionDivider, SectionDividerProps, SectionDividerQuestion } from './components/SectionDivider';
import { SurveyItemProps } from './types';

export const SurveyItem: FC<SurveyItemProps> = ({ surveyItem, ...props }) => {
  switch (surveyItem.surveyItemType) {
    case 'interstitial': {
      switch (surveyItem.type) {
        case 'imageInterstitial': {
          const interstitialProps: ImageInterstitialProps = {
            ...(props as ImageInterstitialProps),
            data: surveyItem as ImageInterstitialType,
          };
          return <ImageInterstitial {...interstitialProps} />;
        }
        case 'infoImageInterstitial': {
          const infoImageInterstitialProps: InfoImageInterstitialProps = {
            ...(props as InfoImageInterstitialProps),
            data: surveyItem as InfoImageInterstitialType,
          };
          return <InfoImageInterstitial {...infoImageInterstitialProps} />;
        }
        case 'sectionDivider': {
          const sectionDividerProps: SectionDividerProps = {
            ...(props as SectionDividerProps),
            data: surveyItem as SectionDividerQuestion,
          };
          return <SectionDivider {...sectionDividerProps} />;
        }
        default: {
          return <SectionDivider {...(props as SectionDividerProps)} data={surveyItem as SectionDividerQuestion} />;
        }
      }
    }
    default: {
      const questionProps: QuestionProps = {
        ...(props as QuestionProps),
        question: surveyItem as QuestionType,
      };
      return <Question {...questionProps} />;
    }
  }
};
